import { render, staticRenderFns } from "./mobile-payment.vue?vue&type=template&id=65d03c2d"
import script from "./mobile-payment.vue?vue&type=script&lang=js"
export * from "./mobile-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports